import axios from "axios";

const axiosGroceryInstance = axios.create({
  baseURL: process.env.REACT_APP_API_COMPANY_URL,
  timeout: 30000, // Increased timeout to 30 seconds
  headers:{
    'Content-Type':'application/json'
  }
});

export default axiosGroceryInstance;
